import { JSON, JsonElementType, JsonObject, JsonProperty } from "ta-json";

import Guard from "../../guard";
import { ILoadOption } from "./load-option";
import { LoadOption } from "./load-options";

/**
 * Specifies which properties to load.
 */
export interface IPropertyLoadOption extends ILoadOption {
    /**
     * Gets a list of properties that need to be loaded.
     * This is only useful when {@link LoadOption} is {@link LoadOption.Custom}.
     */
    properties: Array<string>;

    /**
     * Creates a deep clone of this instance.
     */
    deepClone(): IPropertyLoadOption;
}

@JsonObject()
export class PropertyLoadOption implements IPropertyLoadOption {
    /**
     * Load no properties.
     */
    static readonly None: Readonly<IPropertyLoadOption> = new PropertyLoadOption(LoadOption.None);
    /**
     * Load all properties.
     */
    static readonly All: Readonly<IPropertyLoadOption> = new PropertyLoadOption(LoadOption.All);

    @JsonProperty("load_option")
    loadOption: LoadOption = LoadOption.None;

    @JsonProperty("properties")
    @JsonElementType(String)
    properties: Array<string> = [];

    constructor(param?: LoadOption | Array<string> | string | PropertyLoadOption) {
        if (param == null) {
            return;
        } else if (param instanceof PropertyLoadOption) {
            this.loadOption = param.loadOption;
            this.properties = [...param.properties];
        } else if (typeof param === "string") {
            Guard.stringNotNullOrEmpty(param);
            this.loadOption = LoadOption.Custom;
            this.properties = [param];
        } else if (param instanceof Array) {
            Guard.arrayNotEmpty(param);
            this.loadOption = LoadOption.Custom;
            this.properties = [...param];
        } else {
            this.loadOption = param;
        }
    }

    deepClone(): IPropertyLoadOption {
        return JSON.deserialize<PropertyLoadOption>(JSON.serialize(this), PropertyLoadOption);
    }
}
